import React, { useState, useEffect, useContext } from "react";
import * as S from "./styles";

import TablePagination from "@mui/material/TablePagination";
import { makeStyles } from "@mui/styles";

import { toast } from "react-toastify";
import { Context } from "../../context/globalContext";

import EditParameterPoPup from "../../components/EditParameterPopUp";
import SkeletonListItem from "../SkeletonListItem";
import Parameter from "../../services/parameter";

const useStyles = makeStyles({
  caption: {
    padding: 8,
    fontSize: "1.25rem",
  },
  toolbar: {
    "& > p:nth-of-type(2)": {
      fontSize: "1.25rem",
      color: "red",
      fontWeight: 600,
    },
  },
});

export default function EditParametersComponent({ history, pageFilter }) {
  const { setIsLoading, isLoading } = useContext(Context);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const { pageLimit, setPageLimit } = useContext(Context);
  const [popupOpen, setPopupOpen] = useState(false);
  const [parameterSelected, setParameterSelected] = useState({
    id: null,
    chave: null,
    valor: null,
    descricao: null,
    tipoParametroValor: null,
  });
  const [loading, setLoading] = useState(false);

  const [parameters, setParameters] = useState([]);

  async function getAllData(page = 0) {
    try {
      setIsLoading(true);

      const response = await Parameter.findAllParameters(page, pageLimit);

      if (response && (response.status === 201 || response.status === 200)) {
        setParameters(response.data.content);
        setPage(page);
        setTotalPages(response.data.totalPages);
        setTotalElements(response.data.totalElements);
      } else if (!response) {
        setParameters([]);
        setTotalPages(0);
        setTotalElements(0);
        toast.error("Erro ao buscar parâmetros.");
      }

      setIsLoading(false);
    } catch (err) {
      setTotalPages(0);
      setTotalElements(0);
      setParameters([]);
      setIsLoading(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar parâmetros.");
      }
    }
    setLoading(!loading);
  }

  useEffect(() => {
    if (pageFilter) {
      setPage(pageFilter);
    }

    getAllData(pageFilter);
  }, [pageFilter]);

  const reloadPage = (page) => {
    history.replace(`?page=${page}`);
  };

  return (
    <>
      <S.Container>
        <S.Card>
          <br />
          <S.CardHeader>
            <span>
              {`${totalElements} parâmetro${
                totalElements > 1 ? "s" : ""
              } cadastrado${totalElements > 1 ? "s" : ""} no sistema`}
            </span>
          </S.CardHeader>

          {!isLoading ? (
            <S.CardBody>
              {parameters &&
                parameters?.map((parameter) => {
                  return (
                    <>
                      <S.Custumer>
                        <S.Info
                          onClick={() => {
                            setPopupOpen(true);
                            setParameterSelected({
                              id: parameter.id,
                              chave: parameter.chave,
                              valor: parameter.valor,
                              descricao: parameter.descricao,
                              tipoParametroValor: parameter.tipoParametroValor,
                            });
                          }}
                        >
                          <div className="dataCard">
                            <h4>Chave:</h4>
                            <h4>Descrição:</h4>
                            <h4>Valor:</h4>
                          </div>
                          <div className="dataCard">
                            <h4 className="h4-info">{parameter?.chave}</h4>
                            <h4 className="h4-info">{parameter?.descricao}</h4>
                            <h4 className="h4-info">
                              {parameter?.tipoParametroValor === "BOOLEAN"
                                ? parameter?.valor === "1"
                                  ? "Sim"
                                  : "Não"
                                : parameter?.valor}
                            </h4>
                          </div>
                        </S.Info>
                      </S.Custumer>
                    </>
                  );
                })}

              {totalPages > 1 && (
                <TablePagination
                  component="div"
                  classes={{
                    toolbar: classes.toolbar,
                    caption: classes.caption,
                  }}
                  count={totalElements}
                  page={page}
                  labelDisplayedRows={({ from, to, count }) => {
                    return from + " - " + to + " de " + count;
                  }}
                  onPageChange={(p, newPage) => reloadPage(newPage)}
                  rowsPerPageOptions={[]}
                  rowsPerPage={pageLimit}
                />
              )}
            </S.CardBody>
          ) : (
            <SkeletonListItem />
          )}
        </S.Card>
      </S.Container>
      {popupOpen && (
        <EditParameterPoPup
          setIsLoading={setIsLoading}
          setOpenPopup={setPopupOpen}
          parameterSelected={parameterSelected}
          page={page}
          updateList={getAllData}
        />
      )}
    </>
  );
}
